import React, { Component } from 'react';
import Loadable from 'react-loading-overlay';
import 'video-react/dist/video-react.css';
import apiClient from '../util/api-client';
import iconCam from "images/icon-www.png";
import iconPcAndMobile from "../ui/images/iconPc_Mobile.svg";
import iconPc from "../ui/images/iconPc.svg";
import iconMobile from "../ui/images/iconMobile.svg";
import iconMobileSmall from "../ui/images/iconMobileSmall.svg";
import ListUrlErrorsUpload from './ListUrlErrorsUpload';
import AccountLoginSettings from './AccountLoginSettings';
import AdvancedSettings from './AdvancedSettings';
import TableUrlToCapture from './TableUrlToCapture';
import ToggleSectionOfCaptureUrls from './ToggleSectionOfCaptureUrls';
import popupWhenCaptureUrls from '../util/popup_when_capture_urls';

const regex = new RegExp("^(http[s]?:\\//){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
const pdfPageRegex = new RegExp("\\.pdf($|\\?|&|#)|[?&][^=]*=.*\\.pdf", "i");

const MAX_IN_SETTING = 10;
const MAX_URLS = 30;

const deviceOptions = [
  {
    icon: iconPcAndMobile,
    text: "表示サイズ",
    value: "",
    size: "",
    width: "43px",
    height: "24px",
  },
  {
    icon: iconPc,
    text: "デスクトップ大",
    value: "pc",
    size: "1920px",
    width: "30px",
    height: "26px",
  },
  {
    icon: iconPc,
    text: "デスクトップ中",
    value: "laptop",
    size: "1280px",
    width: "30px",
    height: "26px",
  },
  {
    icon: iconMobile,
    text: "タブレット",
    value: "tablet",
    size: "768px",
    width: "20px",
    height: "28px",
  },
  {
    icon: iconMobileSmall,
    text: "スマートフォン",
    value: "smartphone",
    size: "375px",
    width: "14px",
    height: "20px",
  },
];

const savePasswordOptions = [
  {
    text: "保存する",
    value: "save",
  },
  {
    text: "保存しない",
    value: "dont_save",
  }
];

export default class NewMultipleCaptureAkaire extends Component {
  constructor(props) {
    super(props);
    const { id, baseURL, last_page_id, is_create_video_embed, is_create_pass_video, current_total_size } = props;
    this.props = { ...this.props, ...props };
    this.state = {
      isLoading: false,
      loadingText: '',
      urls: [''],
      dragIndex: null,
      maxToast: false,
      captureMode: 'separate',
      urlsErrors: [],
      toggleAccountLoginSettings: false,
      toggleAdvancedSettings: false,
      username: '',
      password: "",
      accUsername: "",
      accPassword: "",
      showBasicPassword: false,
      supportSpecialPage: false,
      supportLazyLoad: false,
      showAccPassword: false,
      deviceSelected: deviceOptions[0],
      savePasswordSelected: savePasswordOptions[0],
      shouldShowUrlErrorsModal: false,
      isProcessing: false,
    }
    this.apiClient = apiClient({ baseURL: baseURL || "/" });
    this.handleChange = this.handleChange.bind(this);
    this.handleSelectSavePassword = this.handleSelectSavePassword.bind(this);
    this.checkboxChange = this.checkboxChange.bind(this);
    this.showPopupCaptureUrl = this.showPopupCaptureUrl.bind(this);
    this.addUrl = this.addUrl.bind(this);
    this.handleDeleteUrl = this.handleDeleteUrl.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
    this.getAccountByDomain = this.getAccountByDomain.bind(this);
    this.handleCaptureUrls = this.handleCaptureUrls.bind(this);
  }

  toggleAccountLoginSettings = () => {
    if (!!this.state.toggleAccountLoginSettings) {
      this.setState({ toggleAccountLoginSettings: false });
    } else {
      this.resetAccountLoginSetting();
    }
  };

  toggleAdvancedSettings = () => {
    if (!!this.state.toggleAdvancedSettings) {
      this.setState({ toggleAdvancedSettings: false });
    } else {
      this.resetAdvancedSettings();
    }
  };

  resetAdvancedSettings = () => {
    this.setState({
      toggleAdvancedSettings: true,
      supportSpecialPage: false,
      supportLazyLoad: false,
    });
  };

  resetAccountLoginSetting = () => {
    this.setState({
      toggleAccountLoginSettings: true,
      username: "",
      password: "",
      accUsername: "",
      accPassword: "",
      showBasicPassword: false,
      showAccPassword: false,
    });
  }

  changeUrl = (event, index) => {
    const newUrls = [...this.state.urls];
    newUrls[index] = event.target.value;
    this.setState({ urls: newUrls });
  }

  // テキストからURL候補を抽出（改行/タブ/空白/カンマ区切り）
  extractUrls = (text) => {
    if (!text) return [];
    return text
      .split(/[\r\n\t ,]+/)
      .map((u) => u.trim())
      .filter((u) => /^https?:\/\//i.test(u));
  }

  // 既存と貼付分の重複を除いて、上から順に先頭へ挿入（addUrlと同じ向き）
  showMaxUrlsToast = () => {
    this.setState({ maxToast: true });
    if (this._maxToastTimer) clearTimeout(this._maxToastTimer);
    this._maxToastTimer = setTimeout(() => this.setState({ maxToast: false }), 5000);
  }

  insertUrlsAtTop = (incoming) => {
    if (!incoming || incoming.length === 0) return;
    const current = [...this.state.urls];
    const existing = new Set(current.map((u) => u.trim()).filter((u) => u !== ''));
    const base = current.filter((u) => u.trim() !== '');

    // 重複（既存＋貼付内）を除いたユニークな追加候補を抽出
    const toAdd = [];
    incoming.forEach((url) => {
      const u = url.trim();
      if (u === '') return;
      if (existing.has(u)) return;
      existing.add(u);
      toAdd.push(u);
    });

    if (toAdd.length === 0) return; // 全部重複なら何もしない

    // 既存件数 + 追加件数 が上限超なら、1件も追加せずトーストのみ
    if (base.length + toAdd.length > MAX_URLS) {
      this.showMaxUrlsToast();
      return;
    }

    let result = [...base];
    toAdd.forEach((u) => { result.unshift(u); });
    if (result.length === 0) result = [''];
    this.setState({ urls: result });
  }

  handlePasteUrls = (event) => {
    const text = (event.clipboardData || window.clipboardData).getData('text');
    const urls = this.extractUrls(text);
    if (urls.length === 0) return; // URLが無ければ通常のペースト動作に任せる
    event.preventDefault();
    this.insertUrlsAtTop(urls);
  }

  handleDropUrl = (event) => {
    const dt = event.dataTransfer;
    if (!dt) return;
    const uri = dt.getData('text/uri-list') || dt.getData('text/plain') || dt.getData('URL');
    const urls = this.extractUrls(uri);
    if (urls.length === 0) return;
    event.preventDefault();
    this.insertUrlsAtTop(urls);
  }

  setDragIndex = (index) => {
    this.setState({ dragIndex: index });
  }

  handleReorderUrl = (toIndex) => {
    const { dragIndex } = this.state;
    if (dragIndex === null || dragIndex === toIndex) {
      this.setState({ dragIndex: null });
      return;
    }
    const newUrls = [...this.state.urls];
    const [moved] = newUrls.splice(dragIndex, 1);
    newUrls.splice(toIndex, 0, moved);
    this.setState({ urls: newUrls, dragIndex: null });
  }

  handleDeleteUrl = (item, index) => {
    const newUrls = [...this.state.urls];
    if (newUrls.length === 1) {
      newUrls[0] = ''
    } else {
      newUrls.splice(index, 1);
    }
    this.setState({ urls: newUrls });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  toggleAccPassword = () => {
    this.setState({
      showAccPassword: !this.state.showAccPassword,
    })
  }

  toggleBasicPassword = () => {
    this.setState({
      showBasicPassword: !this.state.showBasicPassword,
    })
  }

  checkboxChange = (event) => {
    const newUrls = [...this.state.urls];
    if (newUrls.length > MAX_IN_SETTING) {
      Popup.alert(`URLが${MAX_IN_SETTING}個以上追加されたため<br>高度なキャプチャ設定は設定できません。`);
      return
    }
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  getAccountByDomain(event, index) {
    apiClient({
      baseURL: Routes.fetch_account_akaire_page_owner_users_path({ link: event.target.value, task_id: this.props.taskID })
    })
      .post()
      .then((response) =>{
        if (response.data?.success) {
          const data = response.data
          if (!data.basic_password && !data.acc_password && !data.basic_id && !data.acc_id) return

          this.setState({
            username: data.basic_id,
            password: data.basic_password,
            accUsername: data.acc_id,
            accPassword: data.acc_password,
            toggleAccountLoginSettings: true,
          })
        }
      })
      .catch(() => {
        Popup.alert("このページにアクセスできません。");
      })
  }

  startLoading = (loadingText, title) => {
    this.fadeInLoader();
    $('.message_overlay').removeClass('d-none')
    this.setLoadingContent(loadingText, title)
    this.setState({ isLoading: true });
  }

  addUrl = () => {
    const newUrls = [...this.state.urls];
    const { supportSpecialPage, supportLazyLoad } = this.state;
    if (((supportSpecialPage || supportLazyLoad) && newUrls.length >= MAX_IN_SETTING)) {
      const number = ((supportSpecialPage || supportLazyLoad) && newUrls.length >= MAX_IN_SETTING) ? MAX_IN_SETTING : MAX_URLS
      Popup.alert(`URLが${number}個以上追加されたため<br>高度なキャプチャ設定は設定できません。`);
      return
    }
    if ( newUrls.length >= MAX_URLS) {
      this.showMaxUrlsToast();
      return
    }
    newUrls.unshift('');
    this.setState({ urls: newUrls });
  }

  handleSelectSavePassword = (value) => {
    let option = savePasswordOptions.filter((option) => option.value === value);
    option = option.length > 0 ? option[0] : savePasswordOptions[0];
    this.setState({ savePasswordSelected: option })
  }

  fromProjectId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_project_id');
  };
  fromTaskId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_task_id');
  }
  fromWorkId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_work_id');
  }
  fromPageId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_page_id');
  }
  fromAkaireFileId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_file_id');
  }
  withNewTask = () => {
    const url = new URL(location.href);
    return url.searchParams.get('with_new_task');
  }
  withNewProject = () => {
    const url = new URL(location.href);
    return url.searchParams.get('with_new_project');
  }
  withNewFile = () => {
    return new URL(location.href).searchParams.get('with_new_file');
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool });
    if(!bool) {
      if($('#uploadNewPagePopup').attr('data-upload-new') == 'true') {
        $('#uploadNewPagePopup').modal('show')
      } else {
        $('#uploadVersionPopup').modal('show')
      }
    }
  }
  open = this.toggle(true)
  close = this.toggle(false)

  resetUrlErrors = () => {
    this.setState({urlsErrors: []})
  }

  handleCaptureUrls = async (event) => {
    const { isProcessing } = this.state;
    if (isProcessing) return;
    this.setState({ isProcessing: true });

    const newUrls = [...this.state.urls];
    const listErrors = newUrls.filter(url => { return !regex.test(url) || pdfPageRegex.test(url) });
    let listUrls = newUrls.filter(url => { return regex.test(url) && !pdfPageRegex.test(url) } );
    if (listErrors.length > 0) {
      if (listUrls.length === 0) listUrls = ['']
      this.setState({urlsErrors: listErrors, shouldShowUrlErrorsModal: true, urls: listUrls})
      this.open.bind(this, 'UrlErrorsModal')
      this.setState({ isProcessing: false });
    } else {
      const {
        username,
        password,
        accUsername,
        accPassword,
        supportSpecialPage,
        supportLazyLoad,
        deviceSelected,
        savePasswordSelected,
      } = this.state;
      // 画面下のURL(=最初に入れた)をファイル1にするため、表示順を逆にして送る
      const urls = [...new Set(newUrls)].reverse()
      event.preventDefault();
      const data = {
        urls: urls,
        acc_username: accUsername,
        acc_password: accPassword,
        username: username,
        password: password,
        supportSpecialPage: supportSpecialPage,
        supportLazyLoad: supportLazyLoad,
        device: deviceSelected.value,
        save_password_auth: savePasswordSelected.value,
        from_project_id: this.fromProjectId(),
        from_task_id: this.fromTaskId(),
        from_work_id: this.fromWorkId(),
        from_page_id: this.fromPageId(),
        from_akaire_file_id: this.fromAkaireFileId(),
        with_new_task: this.withNewTask(),
        with_new_project: this.withNewProject(),
        with_new_file: this.withNewFile(),
        capture_mode: this.state.captureMode,
      };
      this.screenShotUrl(data)
    }
  }

  setLoadingContent = (message, title = null) => {
    this.setState({
      loadingText: (
        <>
          <div style={{ fontWeight: 'bold' }}><p>{title}</p></div>
          <div><p>{message}</p></div>
        </>
      )
    });
  };

  screenShotUrl = (data) => {
    const { onFinish } = this.props;
    this.apiClient
      .post("/screen_shot_multiples", data)
      .then((response) => {
        if (response.data?.success == true) {
          if (window.Popup && window.Popup.confirm) {
            window.Popup.confirm(
              'キャプチャを開始しました。<br>キャプチャ完了後、ご登録のメールアドレス宛に完了通知が送信されます。<br><br>全てのキャプチャが完了するまでお待ちください。',
              { confirmText: 'OK', cancelBtn: false, success: () => { window.location.href = '/projects'; } }
            );
          } else {
            window.location.href = '/projects';
          }
        } else {
          Popup.alert("現在、このURLは、ご利用できません。");
        }
      })
      .catch(() => {
        Popup.alert("このページにアクセスできません。");
        this.setState({ isProcessing: false });
      })
  }

  showPopupCaptureUrl = (text) =>{
    popupWhenCaptureUrls(text);
  }

  fadeInLoader = () => {
    const pageId = $('#uploadVersionPopup').attr('data-page-id')
    if(pageId) {
      $('.preloader').fadeIn();
      setInterval(() => {
        $('.preloader').css('opacity', 0.2)
      }, 200);
    }
  }

  render() {
    const { id, baseURL, last_page_id, is_create_video_embed, is_create_pass_video, current_total_size } = this.props;
    const { loadingText, isLoading, urls, toggleAccountLoginSettings, accUsername, accPassword, showBasicPassword,
            showAccPassword, username, password, savePasswordSelected, toggleAdvancedSettings, supportSpecialPage, supportLazyLoad,
            shouldShowUrlErrorsModal, urlsErrors, isProcessing, captureMode
          } = this.state;
    const isDisableCapture = urls.filter(url => url !== '').length === 0
    var darkGray = 'l-container u-bg--darkGray py-3 mt-2 mt-sm-0 darkGray-animation';
    return (
      <div className="animation-inspector">
        <style>{`
          @media (max-width: 768px) {
            /* 白カードを全面に */
            .create-akaire-box-multiples {
              margin: 0 !important;
              border-radius: 0 !important;
              padding-top: 12px !important;
              padding-left: 10px !important;
              padding-right: 10px !important;
            }
            .darkGray-animation, .l-main, .pane-wrapper { padding-left: 0 !important; padding-right: 0 !important; }
            /* 文字を小さく */
            .create-akaire-multiple-url .create-akaire-box-title-content { font-size: 18px !important; }
            .create-akaire-box-multiples .fs-title-popup-url { font-size: 15px !important; }
            .create-akaire-multiple-url .text-black { font-size: 12px !important; }
            .create-akaire-box-title-content { font-size: 17px !important; }
            .create-akaire-box-multiples, .create-akaire-box-multiples .text-black, .mc-work1, .mc-work2 { font-size: 13px !important; }
            /* 作業1/2 縦積み */
            .mc-work-row { display:block !important; padding:0 !important; max-width:100% !important; }
            .mc-work1, .mc-work2 { flex:1 1 100% !important; min-width:0 !important; width:100%; }
            .mc-work2 { border-left:none !important; padding-left:0 !important; margin-top:12px; border-top:1px dashed #c0c0c0; padding-top:12px; }
            /* テーブルを左右10pxまで広げる */
            .create-akaire-multiple-url .w-80 { width: 100% !important; }
            .create-akaire-multiple-url .border-1px-black { margin-left:0 !important; margin-right:0 !important; }
            .show-table-files { margin-left:0 !important; margin-right:0 !important; }
            /* スマホ時はグレー背景・シャドーを除外して白を全面に */
            .u-bg--darkGray { background: transparent !important; box-shadow: none !important; border-radius: 0 !important; }
            .darkGray-animation { background: transparent !important; box-shadow: none !important; }
            #capture-animation-multiple-files { background: transparent !important; }
          }
        `}</style>
        {this.state.maxToast && (
          <div style={{
            position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)',
            zIndex:999999, background:'#595959', color:'#fff', padding:'18px 28px',
            borderRadius:'8px', boxShadow:'0 6px 20px rgba(0,0,0,0.35)', fontWeight:700, fontSize:'15px',
            textAlign:'center'
          }}>
            まとめアップロードは30件までです。
          </div>
        )}
        <Loadable
          className="loading-overlay"
          active={isLoading}
          zIndex={10000}
        >
          <div className="message_overlay d-none">
            { loadingText }
          </div>
          <div className={darkGray}>
            <div className="l-main">
              <div className="pane-wrapper">
                {/* アニメーション */}
                <div className='create-akaire-box-multiples text-center create-akaire-multiple-url'>
                  <div className='d-flex text-center justify-content-center align-items-center'>
                    <img className="create-akaire-box-icon-upload filter-black-icon"
                      src={iconCam} alt="アップロード" width="50" />
                    <span className='create-akaire-box-title-content ml-4 mt-1'>WEBサイトのURLを校正する</span>
                  </div>
                  <div className='d-flex text-center justify-content-center align-items-center'>
                    <span className="text-black">※一度にキャプチャできるのは最大30ページです。</span>
                  </div>
                  <div className="mt-3 align-center-div">
                    <ToggleSectionOfCaptureUrls
                      title="高度なキャプチャ設定が必要なサイト"
                      toggleState={toggleAdvancedSettings}
                      onToggle={this.toggleAdvancedSettings}
                      onHelpClick={() => this.showPopupCaptureUrl('support-special-page-all')}
                    />

                    {toggleAdvancedSettings && (
                      <AdvancedSettings
                        supportSpecialPage={supportSpecialPage}
                        supportLazyLoad={supportLazyLoad}
                        checkboxChange={this.checkboxChange}
                        showPopupCaptureUrl={this.showPopupCaptureUrl}
                      />
                    )}
                  </div>
                  <div className="mb-3 align-center-div">
                    <ToggleSectionOfCaptureUrls
                      title="ID・PASS設定をする"
                      toggleState={toggleAccountLoginSettings}
                      onToggle={this.toggleAccountLoginSettings}
                      onHelpClick={() => this.showPopupCaptureUrl('support-lazy-load-all')}
                    />

                    {toggleAccountLoginSettings && (
                      <AccountLoginSettings
                        accUsername={accUsername}
                        accPassword={accPassword}
                        showAccPassword={showAccPassword}
                        username={username}
                        password={password}
                        showBasicPassword={showBasicPassword}
                        savePasswordSelected={savePasswordSelected}
                        savePasswordOptions={savePasswordOptions}
                        handleChange={this.handleChange}
                        toggleAccPassword={this.toggleAccPassword}
                        toggleBasicPassword={this.toggleBasicPassword}
                        handleSelectSavePassword={this.handleSelectSavePassword}
                        showPopupCaptureUrl={this.showPopupCaptureUrl}
                      />
                    )}
                  </div>
                  <div className='d-flex text-left mb-2 flex-wrap mc-work-row' style={{gap:'0px', alignItems:'stretch', maxWidth:'900px', margin:'0 auto', justifyContent:'flex-start'}}>
                    <div className='mc-work1' style={{flex:'0 1 420px', minWidth:'300px'}}>
                      <div className='font-weight-bold text-black mb-1'>【作業1】このまとめキャプチャの保存方法を選択してください</div>
                      <label className='d-block mb-1 cursor-pointer text-black'>
                        <input type='radio' name='captureMode' value='separate' checked={captureMode === 'separate'} onChange={() => this.setState({captureMode: 'separate'})} className='mr-2' />
                        別々のファイルにする（URLごとに1ファイル）
                      </label>
                      <label className='d-block mb-0 cursor-pointer text-black'>
                        <input type='radio' name='captureMode' value='single' checked={captureMode === 'single'} onChange={() => this.setState({captureMode: 'single'})} className='mr-2' />
                        同じファイルにまとめる（1ファイルに全URLをページ追加）
                      </label>
                    </div>
                    <div className='mc-work2' style={{flex:'1 1 300px', minWidth:'260px', borderLeft:'1px dashed #c0c0c0', paddingLeft:'24px'}}>
                      <div className='font-weight-bold text-black mb-1'>【作業2】</div>
                      <div className='d-flex align-items-center' style={{gap:'12px', flexWrap:'wrap'}}>
                        <label
                          onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.background = '#eef6ff'; }}
                          onDragLeave={(e) => { e.currentTarget.style.background = '#fff'; }}
                          onDrop={(e) => { e.currentTarget.style.background = '#fff'; this.handleDropUrl(e); }}
                          style={{
                            position:'relative', flex:'0 1 180px', minWidth:'160px', minHeight:'56px',
                            border:'2px dashed #9aa0a6', borderRadius:'8px', background:'#fff',
                            display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center',
                            padding:'8px 12px', color:'#5f6368', fontWeight:700, cursor:'text', marginBottom:0
                          }}>
                          URLをまとめて<br/>貼り付ける
                          <textarea
                            value=""
                            onChange={() => {}}
                            onPaste={this.handlePasteUrls}
                            aria-label="URLをまとめて貼り付ける"
                            style={{
                              position:'absolute', top:0, left:0, width:'100%', height:'100%',
                              opacity:0, cursor:'text', resize:'none', border:'none', padding:0, margin:0
                            }}
                          />
                        </label>
                        <div className='text-black' style={{fontSize:'13px', lineHeight:1.5}}>
                          または<br/>以下よりURLを追加してください。
                        </div>
                      </div>
                    </div>
                  </div>
                  <TableUrlToCapture
                    urls={urls}
                    handleDeleteUrl={this.handleDeleteUrl}
                    changeUrl={this.changeUrl}
                    getAccountByDomain={this.getAccountByDomain}
                    addUrl={this.addUrl}
                    handleCaptureUrls={this.handleCaptureUrls}
                    dragIndex={this.state.dragIndex}
                    setDragIndex={this.setDragIndex}
                    handleReorderUrl={this.handleReorderUrl}
                    handlePasteUrls={this.handlePasteUrls}
                    handleDropUrl={this.handleDropUrl}
                    isDisableCapture={isDisableCapture}
                    isProcessing={isProcessing}
                    onCancel={() => { window.location.href = window.location.origin + '/akaire_feature/akaires' + window.location.search }}
                  />
                </div>
              </div>
              {/* / pane-wrapper */}
            </div>
            {/* / l-main */}
          </div>
          {/* / l-container */}
          <ListUrlErrorsUpload isOpen={shouldShowUrlErrorsModal} onClickClose={this.close.bind(this, 'UrlErrorsModal')}
            urls={urlsErrors} resetUrlErrors={this.resetUrlErrors} />
        </Loadable>
      </div>
    );
  }
}
